// extracted by mini-css-extract-plugin
export default {"footer":"LsmFooter_footer__AFeXm","button":"LsmFooter_button__gQX-l"};